var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    fill: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M808 472.8c13.6-91.2-56-140-151.2-172.8l30.4-123.2-75.2-18.4-30.4 119.2c-20-4.8-40-9.6-60-14.4l30.4-120.8-75.2-18.4-30.4 123.2c-16-4-32-8-48-11.2v-0.4l-104-25.6-20 80s56 12.8 54.4 13.6c30.4 7.2 36 28 35.2 44l-35.2 144.8v0.4c-2.4 5.6-7.2 14.4-20 11.2 0.8 0.8-54.4-13.6-54.4-13.6l-37.6 86.4 98.4 24c18.4 4.8 36 9.6 54.4 14.4l-30.4 124.8 75.2 18.4 30.4-123.2c20 5.6 40 10.4 60 15.2l-30.4 122.4 75.2 18.4 30.4-124.8c128 24 224-7.2 264-113.6 32-85.6-1.6-134.4-68-166.4 48-11.2 84.8-42.4 94.4-108zM600 704c-22.4 89.6-172.8 40.8-220.8 28.8l40-156.8c48 12 200 35.2 180.8 128zm22.4-232c-20.8 83.2-148.8 40.8-190.4 30.4l35.2-142.4c41.6 10.4 176 30.4 155.2 112z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinLogo);
export default __webpack_public_path__ + "static/media/bitcoin-logo.116858e28e919b97f41f92680bc1d8ec.svg";
export { ForwardRef as ReactComponent };